import API from '../../../../../services/api';

export const USERS_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/users?page=${page}${search || ''}`).then(res => res.data);
    },
    getById: async (userId) => {
        return await API.get(`/users/${userId}`).then(res => res.data);
    },
    new: async (user) => {
        return API.post('/users', user).then(res => res.data);
    },
    enableDisable: async (user) => {
        return API.post('/users/estado', user).then(res => res.data);
    },
    update: async (user) => {
        return API.put('/users/' + user.id, user).then(res => res.data);
    },
    updatePercentaje: async (user) => {
        return API.put('/users/' + user.id + '/porcentaje', user).then(res => res.data);
    },
    reportProblem: async (problema) => {
        return API.post('/users/reportar-problema', problema).then(res => res.data);
    }
}